import { RecaptchaVerifier } from 'firebase/auth';

let recaptchaInstance = null;

export const setupRecaptchaVerifier = async (auth, containerId = 'recaptcha-container') => {
  if (!auth || !document.getElementById(containerId)) {
    throw new Error('reCAPTCHA container not ready');
  }

  if (recaptchaInstance) {
    try {
      await recaptchaInstance.clear();
    } catch (e) {
      console.warn('reCAPTCHA clear error:', e);
    }
    recaptchaInstance = null;
  }

  recaptchaInstance = new RecaptchaVerifier(auth, containerId, {
    size: 'invisible',
    callback: () => console.log('reCAPTCHA solved'),
    'expired-callback': () => console.warn('reCAPTCHA expired'),
  });

  await recaptchaInstance.render();
  return recaptchaInstance;
};

export const clearRecaptcha = async () => {
  if (recaptchaInstance?.clear) {
    await recaptchaInstance.clear();
    recaptchaInstance = null;
    console.log('reCAPTCHA cleared');
  }
};